<template>
    <div class="purchasecollection-search">
        <b-row>
             <b-col md="10" sm="12">
                <PageTitle
                    icon="fa fa-search"
                    main="Registro"
                    sub="Pesquisa de Cotação de Compra"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    @click="actionNewpurchasecollection"
                    variant="dark"
                    class="mr-2 mt-2 fa fa-plus"
                >
                </b-button>
                <b-button
                    size="sm"
                    class=" mt-2 fa"
                    :class="icon"
                    @click=";[loadpurchasecollections(), (showTable = !showTable)]"
                    variant="dark"
                >
                </b-button>
            </b-col>
        </b-row>
        <hr />
        <b-row>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Início:"
                    label-for="purchasecollection-search-start_date"
                >
                    <b-form-input
                        id="purchasecollection-search-start_date"
                        type="date"
                        v-model="start_date"
                        v-on:keyup.enter="loadpurchasecollections"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Término:"
                    label-for="purchasecollection-search-end_date"
                >
                    <b-form-input
                        id="purchasecollection-search-end_date"
                        type="date"
                        v-model="end_date"
                        v-on:keyup.enter="loadpurchasecollections"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="3" sm="12">
                <b-form-group
                    label="Empresa:"
                    label-for="purchasecollection-search-company_id"
                >
                    <b-form-select
                        id="purchasecollection-search-company_id"
                        @input="loadpurchasecollections"
                        size="sm"
                        :options="companys"
                        v-model="company_id"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Status:"
                    label-for="purchasecollection-search-purchase_collection_status_id"
                >
                    <b-form-select
                        id="purchasecollection-search-purchase_collection_status_id"
                        size="sm"
                        @input="loadpurchasecollections"
                        :options="documentstatus"
                        v-model="purchase_collection_status_id"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row >
            <b-col md="4" sm="12">
                <hr />
                <template>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                    ></b-pagination>
                    <transition name="slide" type="animation" appear>
                        <b-table
                            id="my-table"
                            class="table-responsive"
                            :per-page="perPage"
                            :current-page="currentPage"
                            hover
                            key="slide"
                            striped
                            :items="purchasecollections"
                            :fields="fieldspurchasecollection"
                        >
                        <template v-slot:cell(actions)="data">
                                 <b-button
                                    title="Cancelar Coleta"
                                    size="sm"
                                    variant="light"
                                    @click="showMsgBoxCancel(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-ban"></i>
                                </b-button>
                                <b-button
                                        title = "Lista de Item" 
                                        variant="light" 
                                        class="mr-2 mt-2"
                                        @click="loadPurchaseRequisitionsItems(data.item)"
                                     >
                                         <i class="fa fa-server"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </transition>
                </template>
            </b-col>
             <b-col md="5" sm="12">
                  <hr />
                  <b-row v-show="showTableItem">
                    <b-col xs="12">
                        <b-button
                            size="sm"
                            title="Adicionar Fornecedor para todos itens"
                            @click="openModalEntityAll"
                            variant="dark"
                            class="mr-2 mt-2 mb-2 fa fa-plus"
                        >
                        </b-button>
                    </b-col>    
                  </b-row>
                 <transition  
                    name="slide" 
                    type="animation" 
                    appear> 
                    <b-table 
                            v-show="showTableItem"
                            class="table-responsive" 
                            hover key="slide" 
                            striped 
                            :items="purchasecollectionitems" 
                            :fields="fieldspurchasecollectionItem"> 
                        <template v-slot:cell(actions)="data">
                                   <b-button
                                    title="Adicionar Fornecedor"
                                    size="sm"
                                    variant="light"
                                    @click="openModalEntity(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-plus"></i>
                                </b-button>
                                <b-button
                                    title = "Lista de Fornecedor" 
                                    variant="light" 
                                    class="mr-2 mt-2"
                                    @click="loadPurchaseEntitys(data.item)"
                                    >
                                        <i class="fa fa-server"></i>
                                </b-button>
                        </template>
                    </b-table>
                </transition>
             </b-col>
            <b-col md="3" sm="12">
                  <transition  
                    name="slide" 
                    type="animation" 
                    appear> 
                    <b-table 
                            v-show="showTableEntity"
                            class="table-responsive" 
                            hover key="slide" 
                            striped 
                            :items="purchasecollectionentitys" 
                            :fields="fieldspurchasecollectionEntity"> 
                        <template v-slot:cell(actions)="data">
                                <b-button
                                    title = "Item(s) de coleta" 
                                    variant="light" 
                                    class="mr-2 mt-2"
                                    @click="actionPurchaseCollectionEntity(data.item)"
                                    >
                                        <i class="fa fa-external-link"></i>
                                </b-button>
                        </template>
                    </b-table>
                </transition>
            </b-col>
        </b-row>
        <b-modal
            id="modalRegisterEntity"
            hide-footer
            ref="modal"
            size="xl"
            title-tag="h6"
            title="Registro de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <EntityModal />
        </b-modal>
           <b-modal
            id="modalEntity"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Consulta de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveCollectionEntity"
        >
            <EntitySearchModal
                @setEntityId="entity_id = $event"
                @setEntityName="entity.name_entity = $event"
                @setEntityCnpjCpf="entity.cnpj_cpf = $event"
            />
        </b-modal>
         <b-modal
            id="modalCollection"
            ref="modal"
            size="lq"
            title-tag="h6"
            title="Adicionar Coleta de Compra"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
             @ok="saveCollection"
        >
         <b-form>
                <b-row>
                     <b-col md="12" sm="12">
                         <b-form-group 
                            label="Centro de Resultado:" 
                            label-for="purchasecollection-cost_center_id">
                            <b-form-select id="purchasecollection-cost_center_id"
                            size="sm"
                            :options="costcenters" 
                            v-model="purchasecollection.cost_center_id" />
                        </b-form-group>
                    </b-col>
                </b-row>
         </b-form>    
        </b-modal>
            <b-modal
                id="modalCollectionEntity"
                ref="modal"
                size="lg"
                title-tag="h6"
                title="Fornecedor"
                :header-bg-variant="headerBgVariant"
                :header-text-variant="headerTextVariant"
                :body-bg-variant="bodyBgVariant"
                :body-text-variant="bodyTextVariant"
                @ok="saveCollectionEntityAll"
            >
            <b-form>
                    <EntitySearchModal
                        @setEntityId="entity_id = $event"
                        @setEntityName="entity.name_entity = $event"
                        @setEntityCnpjCpf="entity.cnpj_cpf = $event"
                    />
            </b-form>    
        </b-modal>
        <b-modal
             id="modalRegisterCollection"
                ref="modal"
                size="xl"
                title-tag="h6"
                title="Coleta de Preço"
                :header-bg-variant="headerBgVariant"
                :header-text-variant="headerTextVariant"
                :body-bg-variant="bodyBgVariant"
                :body-text-variant="bodyTextVariant"
        >
        <RecordPurchaseCollection :purchasecollectionentity = purchasecollectionentity />
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import EntityModal from '../util/EntityModal'
import EntitySearchModal from '../util/EntitySearchModal'
import RecordPurchaseCollection from './RecordPurchaseCollection'
var moment = require('moment')

export default {
    name: 'PurchaseCollectionSearch',
    components: { PageTitle, EntityModal, EntitySearchModal,RecordPurchaseCollection },
    data: function() {
        return {
            mode: 'insert',
            modepurchasecollection: 'insert',
            start_date: null,
            end_date: null,
            purchase_collection_status_id: null,
            company_id: null,
            requisition_employee_id: null,
            entity_id: null,
            type_entity_id: null,
            all_entity: false,
            search: '',
            searchsetparms: {},
            searchEntity: '',
            purchasecollection: {},
            purchasecollectionentity: {},
            purchasecollectionitem:{},
            purchasecollections: [],
            purchasecollectionitems:[],
            purchasecollectionentitys: [],
            documentstatus: [],
            entity: {},
            entitys: [],
            companys: [],
            costcenters: [],
            typeentitys: [],
            entitysshearch: [],
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            showTable: false,
            showTableItem: false,
            showpurchasecollection: false,
            showEntity: false,
            showTableEntity:false,
            perPage: 5,
            currentPage: 1,
            fieldspurchasecollection: [
                  {
                    key: 'purchase_collection_date',
                    label: 'Data Coleta',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : '',
                },
                {
                    key: 'name_cost_center',
                    label: 'Centro de Resultado',
                    sortable: true,
                    variant: 'secondary',
                },               
                {
                    key: 'name_document_status',
                    label: 'Status',
                    sortable: false,
                    variant: 'secondary',
                },
                { key: 'actions', label: 'Ações', variant: 'light' },
            ],
            fieldsEntity: [
                { key: 'id', label: 'Código', sortable: true },
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: false },
                {
                    key: 'blocked',
                    label: 'Bloqueado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não'),
                },
                { key: 'actions', label: 'Ações' },
            ],
            fieldspurchasecollectionItem:[
                    { key: "complements_name", label: "Descrição do Item", sortable:false }, 
                    { key: 'initials', label: 'Und.', sortable: false },       
                    { key: 'quantity', label: 'Requisitado', sortable: false },
                    { key: 'quantity_purchase', label: 'Comprado', sortable: false },
                    { key: 'quantity_sald', label: 'Saldo', sortable: false },
                    { key: 'actions', label: 'Ações' , variant: 'light'},
            ],
             fieldspurchasecollectionEntity:[
                    { key: 'name_entity', label: 'Nome', sortable: true },
                    { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: false },
                    { key: 'actions', label: 'Ações' },
            ]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        filteredListEntity() {
            return this.entitysshearch.filter(entity => {
                return entity.name_entity
                    .toLowerCase()
                    .includes(this.searchEntity.toLowerCase())
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.purchasecollections.length
        },
        rowsEntity() {
            return this.entitysshearch.length
        },
    },
    methods: {
        showMsgBoxRemover(docentry) {
            this.boxCancel = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Excluir o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        this.removepurchasecollection(docentry)
                    }
                })
        },
         showMsgBoxCancel(docentry) {
            this.boxCancel = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Cancelar o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        this.canceledpurchasecollection(docentry)
                    }
                })
        },
        formatDate(date) {
            return moment.utc(date).format('YYYY-MM-DD')
        },
        async loadEntitys() {
            if (this.compan.id) {
                const url = `${baseApiUrl}/entitysallcompany/${this.compan.id}/?type_entity_id=${this.type_entity_id}`
                await axios.get(url).then(res => {
                    this.entitysshearch = res.data
                })
            } else {
                this.$toasted.global.defaultError({ msg: 'Logar na Empresa' })
            }
        },

        async saveCollection(){

                this.purchasecollection.company_id = this.compan.id
                this.purchasecollection.purchase_collection_status_id = 1
                this.purchasecollection.user_id = this.user.id
                this.purchasecollection.purchase_collection_date = moment().format('YYYY-MM-DD')

                const method = this.purchasecollection.id ? 'put' : 'post'
                    const id = this.purchasecollection.id ? `/${this.purchasecollection.id}` : ''
                    await axios[method](`${baseApiUrl}/purchasecollections${id}`, this.purchasecollection)
                        .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        })
                        .catch(showError)
        },
        async saveCollectionEntity(){

                this.purchasecollectionentity.purchase_collection_id = this.purchasecollectionitem.purchase_collection_id
                this.purchasecollectionentity.purchase_requisition_id = this.purchasecollectionitem.purchase_requisition_id
                this.purchasecollectionentity.collection_entity_company_id = this.compan.id
                this.purchasecollectionentity.user_id = this.user.id
                this.purchasecollectionentity.entity_id = this.entity_id
                this.purchasecollectionentity.all_entity = this.all_entity
                this.purchasecollectionentity.item_id = this.purchasecollectionitem.item_id
                this.purchasecollectionentity.quantity_sald = this.purchasecollectionitem.quantity_sald
               
                    const method = 'post'
                    
                    await axios[method](`${baseApiUrl}/purchasecollectionentitys`, this.purchasecollectionentity)
                        .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        })
                        .catch(showError)
        },
        async saveCollectionEntityAll(){

                this.purchasecollectionentity.purchase_collection_id = this.purchasecollectionitem.purchase_collection_id
                this.purchasecollectionentity.collection_entity_company_id = this.compan.id
                this.purchasecollectionentity.user_id = this.user.id
                this.purchasecollectionentity.entity_id = this.entity_id
                this.purchasecollectionentity.all_entity = this.all_entity
               
                    const method = 'post'
                    
                    await axios[method](`${baseApiUrl}/purchasecollectionentitys`, this.purchasecollectionentity)
                        .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        })
                        .catch(showError)
        },
        async loadpurchasecollections() {

                const url = `${baseApiUrl}/purchasecollectionsearchdate/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&requisition_employee_id=${this.requisition_employee_id}&purchase_collection_status_id=${this.purchase_collection_status_id}`
                await axios.get(url).then(res => {
                    this.purchasecollections = res.data
                    this.showTableItem = false
                })
        },
        async confirmpurchasecollection(purchasecollection) {
            if (purchasecollection.id) {
                await axios
                    .get(`${baseApiUrl}/purchasecollections/${purchasecollection.id}`)
                    .then(res => (this.purchasecollection = res.data))
                    .catch(showError)

                this.purchasecollection.user_update_id = this.user.id
                this.purchasecollection.update_date = this.formatDate(Date())
                if (this.purchasecollection.purchase_collection_status_id === 1) {
                    this.purchasecollection.purchase_collection_status_id = 2
                } else if (this.purchasecollection.purchase_collection_status_id === 2) {
                    this.purchasecollection.purchase_collection_status_id = 1
                }
                const method = 'put'
                const id = `/${purchasecollection.id}`
                await axios[method](
                    `${baseApiUrl}/purchasecollections${id}`,
                    this.purchasecollection
                )
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadpurchasecollections()
                    })
                    .catch(showError)
            }
        },
        async canceledpurchasecollection(purchasecollection) {
            this.purchasecollection = { ...purchasecollection }

            if (this.purchasecollection.id) {
                this.purchasecollection.user_canceled_id = this.user.id
                this.purchasecollection.canceled_date = this.formatDate(Date())

                this.purchasecollection.purchase_collection_status_id = 5

                const method = this.purchasecollection.id ? 'put' : 'post'
                const id = this.purchasecollection.id
                    ? `/${this.purchasecollection.id}`
                    : ''
                await axios[method](
                    `${baseApiUrl}/purchasecollections${id}`,
                    this.purchasecollection
                )
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadpurchasecollections()
                    })
                    .catch(showError)
            }
        },

        async removepurchasecollection(purchasecollection) {
            const id = purchasecollection.id
            await axios
                .delete(`${baseApiUrl}/purchasecollections/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadpurchasecollections()
                })
                .catch(showError)
        },
        async setEntity() {
            const url = `${baseApiUrl}/entitys/${this.entity_id}`
            await axios(url).then(res => (this.entity = res.data))
        },
        actionEditpurchasecollection(purchasecollection) {
            if (purchasecollection.requisition_date)
                purchasecollection.requisition_date = this.formatDate(
                    purchasecollection.requisition_date
                )

            this.$router.push({
                name: 'RecordPurchaseRequisition',
                params: { id: purchasecollection.id },
                query: { purchasecollectionbase: purchasecollection },
            })
        },
        async loadDocumentStaus() {
            const url = `${baseApiUrl}/documentstatus`
            await axios.get(url).then(res => {
                this.documentstatus = res.data.map(documentstatu => {
                    return {
                        value: documentstatu.id,
                        text: documentstatu.name_document_status,
                    }
                })
            })
        },
        async loadCompanys() {
            const url = `${baseApiUrl}/companys`
            await axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
        },
        actionNewpurchasecollection() {
            if (!this.compan) {
                this.$toasted.global.defaultError({ msg: 'Logar na Empresa' })
            } else {
                this.purchasecollection = {}
                 this.$bvModal.show('modalCollection') 
               
            }
        },
        async loadTypeEntitys() {
            const url = `${baseApiUrl}/typeentitysall`
            await axios.get(url).then(res => {
                this.typeentitys = res.data.map(typeentity => {
                    return { value: typeentity.id, text: typeentity.name }
                })
            })
        },
        openModalEntity(item) {

            this.purchasecollectionitem = {...item}
            this.$bvModal.show('modalEntity')
        },
        openModalEntityAll() {
            this.all_entity = true
            this.$bvModal.show('modalCollectionEntity')
        },
        hideModal() {
            this.$bvModal.hide('modalEntity')
        },
        async loadPurchaseRequisitionsItems(purchasecollection){

            const id = purchasecollection.id
            const url = `${baseApiUrl}/purchasecollectionshandlebalance/${id}`
            await axios.get(url).then(res => {
                this.purchasecollectionitems = res.data
                this.showTableItem = true
            })
        },
        async loadPurchaseEntitys(purchasecollectionitem){

            const {purchase_collection_id,item_id} = purchasecollectionitem
            const url = `${baseApiUrl}/purchasecollectionentityitemiditems/${purchase_collection_id}/?item_id=${item_id}`
            await axios.get(url).then(res => {
                this.purchasecollectionentitys = res.data
                this.showTableEntity = true
            })
        },
        async loadCostCenter() {
                const url = `${baseApiUrl}/purchasecollectionsbalance/${this.compan.id}`
                await axios.get(url).then(res => {
                    this.costcenters = res.data.map(costcenter => {
                        return { value: costcenter.id, text: costcenter.name_cost_center }
                        })
                    })
        },
        actionPurchaseCollectionEntity(item) {
          
                this.purchasecollectionentity = {...item}
                this.$bvModal.show('modalRegisterCollection')
            
        },  
     
    },
    mounted() {
        if (!this.compan) {
            this.$toasted.global.defaultWarning({ msg: 'Logar na Empresa' })
        } else {
            this.start_date = moment()
                .startOf('month')
                .format('YYYY-MM-DD')
            this.end_date = moment()
                .endOf('month')
                .format('YYYY-MM-DD')
            this.company_id = this.compan.id
            this.loadCompanys()
            this.loadCostCenter()
            this.loadTypeEntitys()
            this.loadDocumentStaus()
            this.loadpurchasecollections()
            this.showTable = true
        }
    },
}
</script>

<style>

#modalRegisterCollection input {
    font-size: 0.7rem;
}

#modalRegisterCollection button {
    font-size: 0.7rem;
}

#modalRegisterCollection select {
    font-size: 0.7rem;
}



#modalCollectionEntity input {
    font-size: 0.7rem;
}

#modalCollectionEntity button {
    font-size: 0.7rem;
}

#modalCollectionEntity select {
    font-size: 0.7rem;
}


#modalCollection button {
    font-size: 0.7rem;
}

#modalCollection select {
    font-size: 0.7rem;
}



.purchasecollection-search {
    font-size: 0.7rem;
}

.purchasecollection-search input,
label,
form {
    font-size: 0.7rem;
}
.purchasecollection-search button {
    font-size: 0.7rem;
}

.purchasecollection-search select {
    font-size: 0.7rem;
}

.purchasecollection-search table {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
